import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

const ChangeHistoryWrapper = styled(Flex)`
  padding: 1.5rem;
  margin-top: 1rem;
  flex-direction: column;
  background: ${toColorString(color.base.snowWhite)};
  border: 1px solid var(--if-border);
  border-radius: 4px;
`;

export default ChangeHistoryWrapper;
